import { api } from "./api";

type LocaleResponse = LocaleResult[];

export interface LocaleResult {
  code: string;
  name: string;
  icon?: string;
}

export const authService = {
  async login(username: string, password: string): Promise<{ success: boolean; token: string }> {
    // Implementación real: llamada a API, etc.
    return { success: true, token: 'mock-token' };
  }
  ,
  async logout(): Promise<{ success: boolean }> {
    // Simulación de cierre de sesión
    return { success: true };
  },

  async getUser(token: string): Promise<{ username: string; roles: string[] }> {
    // Simulación de obtención de usuario
    if (!token) {
      return { username: '', roles: [] };
    }
    return { username: 'usuario', roles: ['admin'] };
  }
  ,
  async refreshToken(token: string): Promise<{ success: boolean; newToken: string }> {
    // Simulación de refresco de token
    if (token === 'expired') {
      return { success: false, newToken: '' };
    }
    return { success: true, newToken: 'new-mock-token' };
  },

  isAuthenticated(token: string): boolean {
    // Simulación de validación de autenticación
    return token === 'mock-token' || token === 'new-mock-token';
  },

  async changeLocale(locale: string): Promise<any> {
    const { data } = await api.patch(`/user/change-country/${locale}`);
    return data;
  },

  async getLocale(): Promise<LocaleResponse> {
    const { data } = await api.get('/user/countries');
    return data;
  }
  // Puedes agregar más métodos aquí según lo necesites
};

